/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";

export const OfferEditForm = (props) => {
  console.log(props);
  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Title: props.item.copy ? 'copy of ' + props.item.Title : props.item.Title ?? '',
    Description: props.item.Description ?? '',
    TranslatedDescription: props.item.TranslatedDescription ?? "",
    DisplayTitle: props.item.DisplayTitle,
    TranslatedDisplayTitle: props.item.TranslatedDisplayTitle ?? "",
    StartDateTime: utility.convertMiliToDateTimeStringWithoutFramesWithT(props.item.StartDateTime),
    EndDateTime: utility.convertMiliToDateTimeStringWithoutFramesWithT(props.item.EndDateTime),
    PriceCode: props.item.PriceCode ?? {},
    OfferType: { _id: props.item.OfferType, Description: utility.getKeyByValue(OFFER_TYPE, props.item.OfferType) },
    TransmissionType: props?.item?.TransmissionType,
    Runs: props.item.Runs ?? '',
    IsPayPerTime: props.item.IsPayPerTime ?? false,
    Archive: props.item.Archive ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [pricecode, setPriceCode] = useState([]);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
      const timeoutRef = useRef(null);
  
  

  useEffect(() => {
    loadcombo();
  }, [])

  const loadcombo = async () => {
    var priceCodeRes = await API.getDataLookup(ENTITYNAME.PRICECODE, { sort: { Description: 1 } });
    setPriceCode(priceCodeRes.data);

    const transmissionTypesRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes, { sort: { Description: 1 } });
    setTransmissionTypes(transmissionTypesRes.data);

    if (props?.item?.SID == 0) {
      setDataItem({ ...dataItem, TransmissionType: utility.getDefaultItem(transmissionTypesRes.data) })
    } else {
      setDataItem({ ...dataItem, TransmissionType: (props?.item?.TransmissionType && Object.keys(props?.item?.TransmissionType)?.length > 0) ? props?.item?.TransmissionType : utility.getDefaultItem(transmissionTypesRes.data) });
    }
  }
  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Title == undefined || dataItem.Title.trim().length == 0 || dataItem.Title == "") {
      toast.error(`${lang.please_enter_title_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.DisplayTitle == undefined || dataItem.DisplayTitle.trim().length == 0 || dataItem.DisplayTitle == "") {
      toast.error(`${lang.please_enter_display_title_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      toast.error(`${lang.please_enter_description_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    // if (dataItem.TranslatedDisplayTitle == undefined || dataItem.TranslatedDisplayTitle.trim().length == 0 || dataItem.TranslatedDisplayTitle == "") {
    //   toast.error(`${lang.please_enter_translated_display_title_error_message}`, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return false;
    // }  
    // if (dataItem.TranslatedDescription == undefined || dataItem.TranslatedDescription.trim().length == 0 || dataItem.TranslatedDescription == "") {
    //   toast.error(`${lang.please_enter_translated_description_error_message}`, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return false;
    // }  

    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {

      let [startDate, startTime] = dataItem.StartDateTime.split('T');
      let [endDate, endTime] = dataItem.EndDateTime.split('T');

      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        Title: dataItem.Title,
        Description: dataItem.Description,
        TranslatedDescription: dataItem.TranslatedDescription,
        DisplayTitle: dataItem.DisplayTitle,
        TranslatedDisplayTitle: dataItem.TranslatedDisplayTitle,
        StartDateTime: utility.convertStringDatetoMilliseconds(startDate) + utility.convertShortTimeStringToMilliSeconds(startTime),
        EndDateTime: utility.convertStringDatetoMilliseconds(endDate) + utility.convertShortTimeStringToMilliSeconds(endTime),
        PriceCode: dataItem.PriceCode,
        OfferType: dataItem.OfferType._id,
        TransmissionType: dataItem?.TransmissionType && Object.keys(dataItem?.TransmissionType).length > 0 ? {
          _id: dataItem?.TransmissionType?._id,
          Name: dataItem?.TransmissionType?.Name,
          IsDefault: dataItem?.TransmissionType?.IsDefault
        } : {},
        Runs: dataItem.Runs,
        IsPayPerTime: dataItem.IsPayPerTime ?? false,
        Archive: dataItem.Archive ?? false,
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.OFFER, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OFFER, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.OFFER);
        props.cancelEdit();
        props.refresh();
      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const onChangeForm = (e) => {
    console.log(dataItem)
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  
 const [showPriceDetail, setShowPriceDetail] = useState(false);

const handleMouseEnter = () => setShowPriceDetail(true);
const handleMouseLeave = () => setShowPriceDetail(false);
  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Title : "Create Offer"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.title_label} *</label>
                    <input
                      name={"Title"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Title}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.price_code_label}</label>

                    <div
                      className="position-relative price-hover-wrapper"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={pricecode}
                        name="PriceCode"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.PriceCode}
                        onChange={onChangeForm}
                      />

                      {showPriceDetail && dataItem.PriceCode && (
                        <div className="price-hover-card right">
                          <div><b>Description:</b> {dataItem?.PriceCode?.Description}</div>
                          <div><b>Currency:</b> {dataItem.PriceCode?.Currency?.Description}</div>
                          <div><b>Code:</b> {dataItem?.PriceCode?.Code}</div>
                          <div><b>Price:</b> {dataItem?.PriceCode?.Price}</div>
                          <div><b>Days:</b> {dataItem?.PriceCode?.Days}</div>
                          <div><b>Duration:</b> {dataItem?.PriceCode?.Duration ? utility.convertMilisecondsToStringWithFrames(dataItem?.PriceCode?.Duration) : "00:00:00:00"}</div>
                        </div>
                      )}
                    </div>
                  </div>

                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.display_title_label} *</label>
                    <input
                      name={"DisplayTitle"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.DisplayTitle}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                      name={"Description"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Description}
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.translated_display_title_label} *</label>
                    <input
                      name={"TranslatedDisplayTitle"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.TranslatedDisplayTitle}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.translated_Description_label} *</label>
                    <input
                      name={"TranslatedDescription"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.TranslatedDescription}
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.start_date_time_label} *</label>
                    <input
                      name="StartDateTime"
                      type="datetime-local"
                      className="form-control form-control-sm"
                      value={dataItem?.StartDateTime}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.end_date_time_label} *</label>
                    <input
                      name="EndDateTime"
                      type="datetime-local"
                      className="form-control form-control-sm"
                      value={dataItem?.EndDateTime}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label htmlFor="">{lang.transmission_type_label} </label>
                    <DropDownList
                      style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                      data={transmissionTypes}
                      name={"TransmissionType"}
                      textField="Name"
                      dataItemKey="_id"
                      value={dataItem.TransmissionType}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="">{lang.runs_label}</label>
                    <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChangeForm(e)} min={0} />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-6" >
                    <label>{lang.offer_type_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(OFFER_TYPE).map((obj) => {
                          return {
                            _id: OFFER_TYPE[obj],
                            Description: obj
                          }
                        })
                      }
                      name="OfferType"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.OfferType}
                      onChange={onChangeForm}
                    />
                  </div>
                  {dataItem.OfferType.Description === "Subscription" && <div className="col-3 mt-4" >
                    <input type={"checkbox"} name={"IsPayPerTime"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.IsPayPerTime}
                      checked={dataItem.IsPayPerTime} />
                    <label className="ml-1">{lang.pay_per_time_label}</label>
                  </div>
                  }
                  <div className="col-3 mt-4" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>

                </div>

              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};